<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.tc_atual="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Conclusão do último tratamento odontológico iniciado com primeira consulta"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{
              item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
            }}
            <br />
            ({{ item.idade }} {{ item.idade > 1 ? 'anos' : 'ano' }})
          </template>

          <template v-slot:item.tc_atual="{ item }">
            {{ item.tc_atual != null ? formatDate(item.tc_atual) : '' }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                    <!-- <th v-if="exibirCopilot">Suporte</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                    <!-- <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td> -->
                  </tr>
                </tbody>
              </table>

              <div class="container-table-interna">
                <table class="table table-interna">
                  <thead>
                    <tr>
                      <th>
                        Anterior
                        <span
                          v-b-tooltip.hover.right
                          title="Tratamento odontológico concluído anteriormente ao mais atual"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </th>
                      <th>
                        1ª Consulta
                        <span
                          v-b-tooltip.hover.right
                          title="Primeira consulta odontológica onde se iniciou o tratamento atual"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </th>
                      <th>
                        Tempo
                        <span
                          v-b-tooltip.hover.right
                          title="Meses decorridos entre a primeira consulta atual e a conclusão do tratamento odontológico"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </th>
                      <th>
                        Atual
                        <span
                          v-b-tooltip.hover.right
                          title="Tratamento odontológico concluído mais atual"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </th>
                      <th>Equipe</th>
                      <th>Profissional</th>
                      <th>
                        NM
                        <span
                          v-b-tooltip.hover.right
                          title="O numerador é formado por pessoas que estão com o tratamento concluído rescentemente.."
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{ item.anterior }}
                      </td>
                      <td>
                        {{ item.primeira_consulta }}
                      </td>
                      <td>
                        {{ item.tempo != null ? `${item.tempo} meses` : '' }}
                      </td>
                      <td>
                        {{ item.atual }}
                      </td>
                      <td>
                        {{ item.dados.nu_ine || '' }}
                        <span
                          v-if="item.dados.no_equipe != null"
                          v-b-tooltip.hover.right
                          :title="item.dados.no_equipe"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </td>
                      <td>{{ item.dados.no_profissional }}</td>
                      <td>{{ item.dados.nm == 1 ? 'Sim' : '' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <mais-indicadores-tabs
                :key="item.id"
                :cidadao="item"
                indicadorAtual="b2"
              />
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <b-modal
        id="modal-atendimento"
        ref="modal"
        title="Feedback adicional"
        v-model="modal.show"
        centered
        hide-footer
        size="lg"
      >
        <template #modal-title>
          Procedimentos em {{ formatDate(modal.item.dt_atendimento) }}</template
        >
        <div class="modal-atendimento-body" v-if="modal.item != null">
          <table class="table table-interna">
            <thead>
              <tr>
                <th>Código SIGTAP</th>
                <th>Nome</th>
                <th>Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in modal.item.procedimentos"
                :key="index"
              >
                <td>{{ item.co_proced ?? '' }}</td>
                <td>{{ item.no_proced ?? '' }}</td>
                <td>
                  {{ item.tp_proced != '[]' ? item.tp_proced.join(', ') : '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from '../functions.js'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from '../copilot.js'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '150px',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'Concluído',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'tc_atual',
        },
        { text: '', value: 'data-table-expand' },
      ],
      modal: {
        show: false,
        item: null,
      },
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    exibirCopilot() {
      // if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
      //   return true
      // }
      return false
    },

    indexedItems() {
      return (this.cadastros || []).map((item, index) => {
        let dadosRaw = item.dados

        if (typeof dadosRaw === 'string') {
          try {
            dadosRaw = JSON.parse(dadosRaw)
          } catch (error) {
            dadosRaw = null
          }
        }

        // Se for array, utiliza o primeiro registro
        const dados = (Array.isArray(dadosRaw) ? dadosRaw[0] : dadosRaw) || {}

        const formatIfNotNull = (value) =>
          value != null ? this.formatDate(value) : ''

        return {
          ...item,
          id: index,
          anterior: formatIfNotNull(dados.tc_anterior),
          primeira_consulta: formatIfNotNull(dados.pcp_atual),
          tempo: dados.tempo_meses ?? null,
          atual: formatIfNotNull(dados.tc_atual),
          dados,
        }
      })
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      if (item.num_trat_concluido > 0) {
        return `table-row-color-green`
      }
      return `table-row-color-red`
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },

    /**
     * Abre o modal de atendimento
     *
     * @param {Object} item
     */
    openModalAtendimento(item) {
      this.modal.show = true
      this.modal.item = item
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}
.tabela .red-color {
  color: red !important;
}
</style>
<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}

.container-table-interna {
  height: 300px;
  overflow-y: scroll;
}
</style>
